import { BeCol, BeCols, BeStack } from "@beos-css/react/index.ts";
import { CodeWell } from "../../CodeWell.tsx";

const SAMPLE = `// a well recolours every .hljs-* role
class Window extends View {
	static count = 0;
	title: string = "Untitled";

	constructor(frame: Rect) {
		super(frame);
		this.resize(640, 480);
		Window.count += 1;
	}
}`;

export function CodeWellDemo() {
	return (
		<section id="demo-code-well">
			<h2>Code well</h2>
			<p>
				A recessed well for highlighted code. Light mode inks the roles with the kit's categorical accents; <code>dark</code> switches to
				the Dracula palette, each ink with its own ProFont ramp, so the antialiasing takes the ink rather than a black fringe.
			</p>
			<BeStack pad="item" className="be-panel">
				<BeCols>
					<BeCol span={8}>
						<CodeWell language="typescript">{SAMPLE}</CodeWell>
					</BeCol>
					<BeCol span={8}>
						<CodeWell language="typescript" dark>
							{SAMPLE}
						</CodeWell>
					</BeCol>
				</BeCols>
			</BeStack>
		</section>
	);
}
